export default "__VITE_ASSET__DXTEX8yO__"